<template>
    <div class="work-temp-outer">
        <div class="work-header flex-r-b-c">
            <div class="head-title">我的作品</div>
            <div class="filter-box flex-r-s-c">
                <div class="select-box1">
                    <el-select popper-class="ft-select" style="width: 100%;" v-model="searchForm.status"
                        placeholder="状态">
                        <el-option v-for="item in options" :key="item.text" :label="item.label" :value="item.text">
                        </el-option>
                    </el-select>
                </div>
                <div class="select-box2">
                    <el-date-picker :value-format="value_format" popper-class="ft-date-picker" range-separator="-"
                        style="width: 100%;" prefix-icon="el-icon-date" v-model="searchForm.search_date"
                        type="daterange" :picker-options="pickerOptions" start-placeholder="开始日期" end-placeholder="结束日期"
                        align="right">
                    </el-date-picker>
                </div>
                <div @click="query()" class="sc-btn flex-c-c-c cur">查询</div>
                <div @click="reset()" class="flex-c-c-c ref-btn cur"><i class="el-icon-refresh"></i></div>
            </div>
        </div>
        <div class="work-list">
            <el-row :gutter="20">
                <el-col v-if="list.length == 0" :span="24">
                    <div style="height: 500px;" class="flex-c-c-c">
                        <el-empty description="暂无数据"></el-empty>
                    </div>
                </el-col>
                <el-col v-for="v in list" :span="6">
                    <div @click="openDialog(v)" class="at-box cur">
                        <div class="at-img-box">
                            <div v-if="v.status_text" :class="'type' + v.status" class="m-tag">{{ v.status_text || '' }}
                            </div>
                            <img class="at-img" :src="v.goods_img_url" alt="">
                        </div>
                        <div class="info-box">
                            <div :title="v.goods_name || ''" class="at-title hideLine1">{{ v.goods_name || "" }}</div>
                            <div class="tt-sub">
                                登记时间：{{ v.create_time || "" }}
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div v-if="list.length > 0" class="vcenter pagination">
            <el-pagination background layout="prev, pager, next" :total="total" @prev-click="prevClick"
                @next-click="nextClick" @size-change="sizeChange" @current-change="currentChange">
            </el-pagination>
        </div>
        <el-dialog :destroy-on-close="true" :append-to-body="true" custom-class="workdetail-dialog"
            :visible.sync="dialogVisible" width="920px">
            <div class="dialog-box">
                <div class="d-header flex-r-b-c">
                    <div class="header-text">作品详情</div>
                    <div class="close-btn flex-c-c-c cur" @click="closeDialog()"><i class="el-icon-close"></i>
                    </div>
                </div>
                <div class="info-top flex-r-b-c">
                    <div class="info-text">
                        <div class="work-title">{{ workDetail.goods_name || '' }}</div>
                        <div class="work-des">艺术家：{{ workDetail.artist_name || '' }} | 登记时间：{{ workDetail.create_time ||
                            '' }}</div>
                    </div>
                    <div class="status-box">
                        <div :class="'type' + workDetail.status" class="status-pill">{{ workDetail.status_text || '' }}
                        </div>
                    </div>
                </div>
                <!-- <div class="prg-box">
                    <div class="prg-li flex-c-c-c">
                        <div class="green-dot">1</div>
                        <div class="prg-text vcenter">登记申请</div>
                    </div>
                    <div class="prg-poly line-green"></div>
                    <div class="prg-li flex-c-c-c">
                        <div class="green-dot">2</div>
                        <div class="prg-text vcenter">申请复核</div>
                    </div>
                    <div class="prg-poly line-gray"></div>
                    <div class="prg-li flex-c-c-c">
                        <div class="gray-dot">3</div>
                        <div class="prg-text vcenter">物理采集</div>
                    </div>
                    <div class="prg-poly line-gray"></div>
                    <div class="prg-li flex-c-c-c">
                        <div class="gray-dot">4</div>
                        <div class="prg-text vcenter">证书颁发</div>
                    </div>
                </div> -->
                <div class="form-outer">
                    <collectedit @fetch-data="refreshPage()"
                        :is_edit="workDetail.status == -1 || workDetail.status == 2" ref="collectForm" />
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
let that;
import ty from "@/utils/ty/ty";
import util from "@/common/util.js"
import collectedit from "./collectForm.vue";

export default {
    name: "workList",
    components: {
        collectedit
    },
    props: {
        // list: {
        //     type: Array,
        //     default: () => [],
        // },
    },
    data() {
        return {
            workDetail: {
                id: "",
                goods_name: "",
                goods_img: "",
                status: "",
                create_time: "",
                artist_name: "",
                status_text: "",
                goods_img_url: ""
            },
            value_format: "yyyy-MM-dd",
            searchForm: {
                search_date: "",
                status: "",
            },
            dialogVisible: false,
            pickerOptions: {
                shortcuts: [{
                    text: '昨天',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
                        end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '今天',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        // start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }],
            },
            options: [{
                text: '1',
                label: '已备案'
            }, {
                text: '2',
                label: '处理中'
            }, {
                text: '3',
                label: '已驳回'
            },],
            baseInfo: {
                cnt1: 0,
                cnt2: 0,
                cnt3: 0,

            },
            partnerlist: [],
            total: 0,
            list: [],
            listLoading: false,
        }
    },
    created() {
        that = this;
    },
    mounted() {
    },
    methods: {
        refreshPage() {
            that.dialogVisible = false;
            that.initData();
        },
        closeDialog() {

            this.$nextTick(() => {
                this.dialogVisible = false;
            })
        },
        openDialog(v) {
            this.workDetail = v;
            console.log(this.$refs)
            this.dialogVisible = true;
            this.$nextTick(() => {
                this.$refs.collectForm.formShow(v.id);
            })
        },
        query() {
            that.searchForm.page = 1;
            that.initData();
        },
        reset() {
            that.searchForm = {
                search_date: "",
                status: "",
            };
            that.query();
        },
        initData() {
            that.listLoading = true;
            ty.ajax('web/goods/goods/index', that.searchForm).then((result) => {
                that.list = result.data.data;
                that.total = result.data.meta.totalCount;
                that.listLoading = false;
                that.options = result.data.statusarr
            });
        },
        goPage(path) {
            util.tourl(path)
        },
        prevClick(e) {
            console.log(e)
        },
        nextClick(e) {
            console.log(e)
        },
        sizeChange(e) {
            console.log(e)
        },
        currentChange(e) {
            console.log(e)
        },
    },
};
</script>

<style lang="scss">
@import '../../style.scss'; //所有页面公用
@import '../../style2.scss'; //所有页面公用</style>
<style lang="scss" scoped>
.work-header {
    padding: 14px 18px;
    border-bottom: 1px solid #F2F2F2;


    .filter-box {
        .select-box1 {
            width: 110px;
            margin-right: 10px;
        }

        .select-box2 {
            width: 240px;
            margin-right: 10px;
        }

        .sc-btn {
            width: 66px;
            height: 37px;
            background: #2C5A50;
            font-family: Source Han Sans SC;
            font-weight: 400;
            font-size: 15px;
            color: #FFFFFF;
            margin-right: 10px;

            &:hover {
                transform: scale(1.05);
                transition: all 0.3s ease;
            }
        }

        .ref-btn {
            width: 37px;
            height: 37px;
            background: #F8F7F5;
            color: #333333;
            font-size: 20px;

            &:hover {
                transform: scale(1.05);
                transition: all 0.3s ease;
            }
        }
    }
}

.work-list {
    padding: 20px;
    width: 100%;
    min-height: 540px;

    .at-box {
        margin-bottom: 20px;

        .at-img-box {
            position: relative;
            width: 257px;
            height: 184px;
            border-radius: 9px;
            overflow: hidden;

            .at-img {
                width: 100%;
                height: 100%;
            }

            .m-tag {
                position: absolute;
                top: 6px;
                right: 6px;
                padding: 6px 10px;
                border-radius: 5px;
                color: #fff;
                font-size: 13px;

                &.type4,
                &.type3,
                &.type1 {
                    background: #2DE3B2;
                }

                &.type0 {
                    background: #FD9F42;
                }

                &.type2 {
                    background: #FF3434;
                }

                &.type-1 {
                    background: #b1b1b1;
                    // color: #333333;
                }
            }

        }

        .info-box {
            .at-title {
                font-family: Source Han Serif SC;
                font-weight: 500;
                font-size: 17px;
                color: #1A1A1A;
                line-height: 40px;
            }

            .tt-sub {
                font-family: Source Han Sans SC;
                font-weight: 400;
                font-size: 15px;
                color: #999999;
                // line-height: 29px;
            }
        }

    }
}
</style>
<style lang="scss">
.ft-select {
    .el-select-dropdown__item.selected {
        color: #418676;
    }
}

.ft-date-picker {

    .el-date-table td.end-date span,
    .el-date-table td.start-date span {
        background-color: #2C5A50;
    }

    .el-date-table td.today span {
        color: #55b6a1;
        font-weight: 700;
    }

    .el-picker-panel__shortcut:hover {
        color: #55b6a1;
    }

    .el-date-table td.available:hover {
        color: #55b6a1;
    }
}

.work-header {
    .filter-box {
        .el-select-dropdown__item {
            padding: 0 20px;
        }

        .el-date-editor .el-range-separator {
            width: auto;
        }

        .el-range-editor.is-active,
        .el-range-editor.is-active:hover,
        .el-select .el-input.is-focus .el-input__inner {
            border-color: #418676;
        }

        .el-select .el-input__inner:focus {
            border-color: #418676;
        }

        .el-input__inner,
        .el-date-editor .el-range-input {
            background-color: #F8F7F5;
            border-color: transparent;
            border-radius: 0;
        }

        .el-select .el-input .el-select__caret,
        .el-date-editor .el-range__icon {
            color: #333;
        }

        /* 改变所有el-input的placeholder颜色 */
        .el-input__inner::-webkit-input-placeholder,
        .el-range-input::-webkit-input-placeholder {
            color: #999999;
        }

        .el-input__inner:-moz-placeholder,
        .el-range-input:-moz-placeholder {
            color: #999999;
        }

        .el-input__inner::-moz-placeholder,
        .el-range-input::-moz-placeholder {
            color: #999999;
        }

        .el-input__inner:-ms-input-placeholder,
        .el-range-input:-ms-input-placeholder {
            color: #999999;
        }
    }
}

.work-temp-outer {
    .pagination {
        .el-pagination.is-background .el-pager li:not(.disabled).active {
            background-color: #418676 !important;

            &:hover {
                color: #fff !important;
            }
        }

        .el-pagination.is-background .el-pager li:not(.disabled):hover {
            color: #418676 !important;
        }

        .el-pagination.is-background .btn-next,
        .el-pagination.is-background .btn-prev,
        .el-pagination.is-background .el-pager li {
            background-color: #fff;
        }
    }

}

.workdetail-dialog {
    background: transparent !important;

    .el-dialog__header {
        display: none;
    }

    .el-dialog__body {
        padding: 0;
    }

    .dialog-box {
        width: 100%;
        border-radius: 9px;
        overflow: hidden;
        background-color: #fff;

        .d-header {
            width: 100%;
            height: 59px;
            background: #E9EEED;
            padding: 20px;

            .header-text {
                font-family: Source Han Sans SC;
                font-weight: 500;
                font-size: 18px;
                color: #333333;
            }

            .el-icon-close {
                font-size: 20px;
                color: #7c7c7c;
            }

        }

        .info-top {
            width: 100%;
            padding: 17px 22px;

            .work-title {
                font-family: Source Han Sans SC;
                font-weight: 500;
                font-size: 17px;
                color: #333333;
            }

            .info-text {
                .work-des {
                    font-family: Source Han Sans SC;
                    font-weight: 400;
                    font-size: 13px;
                    color: #999999;
                    margin-top: 10px;
                }
            }

            .status-box {
                .status-pill {
                    width: 96px;
                    height: 37px;
                    border-radius: 18px;
                    font-family: Source Han Sans SC;
                    font-weight: 400;
                    font-size: 15px;
                    color: #FFFFFF;
                    line-height: 37px;
                    text-align: center;

                    &.type4,
                    &.type3,
                    &.type1 {
                        background: #2DE3B2;
                    }

                    &.type0 {
                        background: #FD9F42;
                    }

                    &.type2 {
                        background: #FF3434;
                    }

                    &.type-1 {
                        background: #b1b1b1;
                        // color: #333333;
                    }
                }
            }
        }

        .prg-box {
            display: flex;
            // align-items: center;
            justify-content: center;
            padding: 20px 20px 50px 20px;

            .prg-poly {
                // position: absolute;
                margin: 8px 5px 0 5px;
                width: 165px;
                height: 1px;

                &.line-green {
                    background: #2C5A50;
                }

                &.line-gray {
                    background: #CCCCCC;
                }
            }

            .prg-li {
                position: relative;
                width: 18px;

                .gray-dot {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 18px;
                    height: 18px;
                    background: #CCCCCC;
                    border-radius: 50%;
                    color: #ffffff;
                    font-size: 13px;
                }

                .green-dot {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 21px;
                    height: 18px;
                    background: url("../../../static/progress_dot_bg.png") no-repeat;
                    background-size: 100% 100%;
                    color: #fff;
                    font-size: 13px;
                    padding-left: 4px;
                }

                .prg-text {
                    margin-top: 12px;
                    font-family: Source Han Sans SC;
                    font-weight: 400;
                    font-size: 17px;
                    color: #333333;
                    white-space: nowrap;
                }
            }
        }

        .form-outer {
            border-top: 5px solid #F8F7F5;
            padding: 50px 40px;
        }
    }
}
</style>